import React, { Suspense, lazy, Fragment } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { history } from '../../routers/AppRouter';
import paths from '../../helpers/paths';
import SearchBarSS from '../SearchBar/SearchBarSS';
import DashboardTab from '../DashBoard/DashBoardTab';
import AuthSettings from '../Auth/AuthSettings';
import WhatsAppIcon from '../Social/WhatsAppIcon';
import Loader from '../Loader/Waiting';
import loader from '../../images/loader2.gif';
import loveIcon from '../../images/icons/couple.png';
import deleteIcon from '../../images/icons/delete32.png';
import addIcon from '../../images/icons/add32.png';
import minusIcon from '../../images/icons/minus32.png';
import { getToken } from '../../helpers/auth';
import { getCartDetails, setCartDetails,  deleteSingleCartDetails, } from '../../helpers/cart';
import { setProductCart, fetchProductCart, setCartTotalQuantity } from '../../actions/cart';
import { priceFigure, isPositiveInteger } from '../../helpers/validators';

const Waiting = lazy(() => import('../Loader/Waiting'));
const ShopAll = lazy(() => import('../DropDown/ShopAll'));
const ModalMenu = lazy(() => import('../Modal/ModalMenu'));
const SearchBarBS = lazy(() => import('../SearchBar/SearchBarBS'));
const OnDemand = lazy(() => import('../DropDown/OnDemand'));
const Recommended = lazy(() => import('../DropDown/Recommended'));
const OurLocations = lazy(() => import('../DropDown/Ourlocations'));
const ContactUs = lazy(() => import('../Contact/ContactUs'));
const SmallScreenSearch = lazy(() => import('../SearchBar/SmallScreenSearch'));
const Footer = lazy(() => import('../Footer/Footer'));


class ShoppingCart extends React.Component{
  componentDidMount (){
    const { dispatch } = this.props; 
    try{
      let retrieveCartDetails;
      retrieveCartDetails = JSON.parse(getCartDetails());
      dispatch(setProductCart(retrieveCartDetails));
      dispatch(fetchProductCart(getCartDetails()));
    }catch(err){
      dispatch(setProductCart([]));
      dispatch(fetchProductCart([]));
    };
  };

  componentWillMount (){
    const { dispatch } = this.props; 
    try{
      let retrieveCartDetails;
      retrieveCartDetails = JSON.parse(getCartDetails());
      dispatch(setProductCart(retrieveCartDetails));
      dispatch(fetchProductCart(getCartDetails()));
    }catch(err){
      dispatch(setProductCart([]));
      dispatch(fetchProductCart([]));
    };
  }

  notifyThree = () => {
    return toast("Cart Updated");
  }

  grandTotal = (productArray =[]) => {
    let sumAmount = 0;
    productArray.map((data) => {
      sumAmount += (data.selectedQuantity * data.discounted_price)
    });
    return sumAmount
  }

  render(){
    const {dispatch} = this.props;
    const { cart, fetchCart, cartResponseMessage } = this.props.cart;
    return (
      <div className='dashboard'>
        <Suspense fallback={<Loader/>}>
          <ModalMenu />
          <SmallScreenSearch />
          <SearchBarBS />
          <SearchBarSS />
          <Waiting />
        </Suspense>
          <DashboardTab />
          <AuthSettings />
          <WhatsAppIcon />
        <Suspense fallback={<Loader/>}>
          <ShopAll />
          <OnDemand />
          <Recommended />
          <OurLocations />
          <ContactUs />
        </Suspense>
        <div className='shopping-action-div'>
          {<Fragment>{<div className='cart-callback-message-div'>
            <p className='cart-callback-message'>{!!cartResponseMessage ? cartResponseMessage : `Processing Cart Info...`}</p>
                      </div>}</Fragment>}
          <Suspense fallback={<Loader />}>
            <Fragment>
            {!!fetchCart && fetchCart.length > 0 ? fetchCart.map(data => (
                <div key={`div1${data.reference_id}${data.product_id}`} className='shopping-cart-items'>
                  <div key={`div2${data.reference_id}${data.product_id}`} className='shopping-cart-items-img-describe'>
                    <img key={`img1${data.reference_id}${data.product_id}`} className='shopping-cart-img' src={!!data ? data.image_url1 : loader} title='coozall.com' alt='coozall.com'/>
                    <div key={`div3${data.reference_id}${data.product_id}`} className='shopping-cart-describe'>
                      <p key={`p1${data.reference_id}${data.product_id}`} className='shopping-product-name'>{data.product_name}</p>
                      <p key={`p2${data.reference_id}${data.product_id}`} className='coozall-purchases'>coozall purchases</p>
                      <p key={`p3${data.reference_id}${data.product_id}`}><span key={`s1${data.reference_id}${data.product_id}`} className='shopping-cart-discounted'> {!!data ? `₦ ${priceFigure(data.discounted_price * data.selectedQuantity)}` : `Price Unavailable`}</span> <span key={`s2${data.reference_id}${data.product_id}`} className='shopping-cart-price'><strike>{!!data ? `₦ ${priceFigure(data.price * data.selectedQuantity)}` : `Price Unavailable`}</strike></span></p>
                    </div>
                  </div>

                  <div key={`div4${data.reference_id}${data.product_id}`} className='shopping-cart-items-actions'>
                    <div key={`div5${data.reference_id}${data.product_id}`} className='shopping-cart-items-first-div'>
                      <table key={`table1${data.reference_id}${data.product_id}`} className='shopping-cart-table'>
                        <tbody key={`tbody1${data.reference_id}${data.product_id}`}>
                          <tr key={`tr1${data.reference_id}${data.product_id}`} className='shopping-cart-table-tr'>
                            <td key={`td1${data.reference_id}${data.product_id}`} className='shopping-cart-table-td'><a key={`a1${data.reference_id}${data.product_id}`} href='#'><img src={loveIcon} /></a></td>
                            <td key={`td2${data.reference_id}${data.product_id}`} className='shopping-cart-table-td'><a onClick={() => {
                              let filterRetrievedCartDetails;
                              let retrieveCartDetails;
                              let stringifyRetrievedCart;
                              let reduceParsedCart;
                              retrieveCartDetails = JSON.parse(getCartDetails());
                              filterRetrievedCartDetails = retrieveCartDetails.filter(res => res.productId !== data.product_id);
                              reduceParsedCart = filterRetrievedCartDetails.map(li => li.quantity).reduce((sum, val) => parseInt(sum) + parseInt(val), 0);
                              stringifyRetrievedCart = JSON.stringify(filterRetrievedCartDetails);
                              setCartDetails(stringifyRetrievedCart);
                              retrieveCartDetails = JSON.parse(getCartDetails());
                              dispatch(setProductCart(retrieveCartDetails));
                              dispatch(setCartTotalQuantity(JSON.stringify(reduceParsedCart)));
                              dispatch(fetchProductCart(getCartDetails())); 
                            }} key={`a2${data.reference_id}${data.product_id}`} href='#'><img src={deleteIcon} /></a></td>
                            <td key={`td3${data.reference_id}${data.product_id}`} className='shopping-cart-table-td'><a onClick={() => {
                              let filterRetrievedCartDetails;
                              let retrieveCartDetails;
                              let stringifyRetrievedCart;
                              let reduceParsedCart;
                              retrieveCartDetails = JSON.parse(getCartDetails());
                              filterRetrievedCartDetails = retrieveCartDetails.filter(res => res.productId !== data.product_id);
                              reduceParsedCart = filterRetrievedCartDetails.map(li => li.quantity).reduce((sum, val) => parseInt(sum) + parseInt(val), 0);
                              stringifyRetrievedCart = JSON.stringify(filterRetrievedCartDetails);
                              setCartDetails(stringifyRetrievedCart);
                              retrieveCartDetails = JSON.parse(getCartDetails());
                              dispatch(setProductCart(retrieveCartDetails));
                              dispatch(setCartTotalQuantity(JSON.stringify(reduceParsedCart)));
                              dispatch(fetchProductCart(getCartDetails()));
                            }} key={`a3${data.reference_id}${data.product_id}`} className='shopping-cart-table-td-remove' href='#'>REMOVE</a></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  <div key={`div6${data.reference_id}${data.product_id}`} className='shopping-cart-items-second-div'>
                    <table key={`table2${data.reference_id}${data.product_id}`} className='shopping-cart-table2'>
                      <tbody key={`tbody2${data.reference_id}${data.product_id}`}>
                        <tr key={`tr2${data.reference_id}${data.product_id}`} className='shopping-cart-table-tr'>
                          <td key={`td4${data.reference_id}${data.product_id}`} className='shopping-cart-table-td2'><a onClick={() => {
                            if(isPositiveInteger(data.selectedQuantity) && parseInt(data.selectedQuantity) >= 1){
                              let retrieveCartProduct = getCartDetails();
                              let parseRetrievedCart;
                              let reduceParsedCart;
                              data.selectedQuantity -= 1
                              parseRetrievedCart = JSON.parse(retrieveCartProduct);
                              parseRetrievedCart.filter(res => res.productId === data.product_id ? res.quantity = data.selectedQuantity : res.quantity);
                              reduceParsedCart = parseRetrievedCart.map(li => li.quantity).reduce((sum, val) => parseInt(sum) + parseInt(val), 0);
                              setCartDetails(JSON.stringify(parseRetrievedCart));
                              dispatch(setCartTotalQuantity(JSON.stringify(reduceParsedCart)));
                              return;
                            }else{
                              return;
                            }
                          }} ><img className='shop-cart-act-button' src={minusIcon}  /></a></td>
                          <td key={`td5${data.reference_id}${data.product_id}`} className='shopping-cart-table-td2-middle'><a className='shopping-cart-table-td-remove' href='#'>{!!data ? data.selectedQuantity : `Quantity Unresolved`}</a></td>
                          <td  id={`id2${data.reference_id}${data.product_id}`} className='shopping-cart-table-td2-left'><a onClick={() => {
                            if(isPositiveInteger(data.selectedQuantity) && parseInt(data.selectedQuantity) < parseInt(data.quantity)){
                              let retrieveCartProduct = getCartDetails();
                              let parseRetrievedCart;
                              let reduceParsedCart;
                              data.selectedQuantity += 1;
                              parseRetrievedCart = JSON.parse(retrieveCartProduct);
                              parseRetrievedCart.filter(res => res.productId === data.product_id ? res.quantity = data.selectedQuantity : res.quantity);
                              reduceParsedCart = parseRetrievedCart.map(li => li.quantity).reduce((sum, val) => parseInt(sum) + parseInt(val), 0);
                              setCartDetails(JSON.stringify(parseRetrievedCart));
                              dispatch(setCartTotalQuantity(JSON.stringify(reduceParsedCart)));
                              return;
                            }else{
                              return;
                            }
                          }} ><img  className='shop-cart-act-button' src={addIcon}  /></a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              )) : <Fragment><Loader /></Fragment>}
            </Fragment>
          </Suspense>
          <Suspense fallback={<Loader />}>
            {!!fetchCart && fetchCart.length > 0 ? (
              <div className='shopping-cart-total-div'>
              <table className='shopping-cart-total-table'>
                <tbody>
                  <tr>
                    <td className='shopping-cart-total-table-td'>Total</td>
                    <td className='shopping-cart-total-table-td2'>{!!fetchCart && fetchCart.length > 0 ? `₦ ${priceFigure(this.grandTotal(fetchCart))}` : `0`}</td>
                  </tr>
                </tbody>
              </table>
              <button onClick={() => {
                if(!getToken()){
                  history.push(paths.login);
                }else if(getToken() == "undefined"){
                  history.push(paths.login);
                }else{
                  history.push(paths.payment);
                }
              }} className='shopping-cart-checkout-button'>CHECKOUT</button>
              <button onClick={() => {
                window.location.href = `tel:08036096802`
              }} className='shopping-cart-call-button'>CALL TO ORDER</button>
            </div>
            ) : <Loader />}
          </Suspense>
        </div>
        <Suspense fallback={<Loader/>}>
          <Footer />
        </Suspense>
      </div>
    )
  };
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(ShoppingCart); 
